import { availableTransitions } from './constantHelpers'

export const siteClearance = {
  admin: ['ADMINISTRATOR'],
  director: ['DIRECTOR'],
  responsible: ['RESPONSIBLE'],
  responsibleOperation: ['RESPONSIBLE_OPERATION'],
  collaborator: ['COLLABORATOR'],
  collaboratorServices: ['COLLABORATOR_SERVICES'],
}

export function showSignOnPaperButton(actorRoles, processStatus) {
  const signableByDrAndRs = ['WAITING_TO_SEND_CONTRACT', 'WAITING_TO_SIGN_CONTRACT']
  if (availableTransitions.SIGN_ON_PAPER.includes(processStatus) && isAuthorized(actorRoles, siteClearance.admin)) {
    return true
  } else if (
    availableTransitions.SIGN_ON_PAPER.includes(processStatus) &&
    signableByDrAndRs.includes(processStatus) &&
    (isAuthorized(actorRoles, siteClearance.responsible) || isAuthorized(actorRoles, siteClearance.director))
  ) {
    return true
  } else return false
}

export function showCancelButton(processType, processStatus) {
  const cancelableStatusForConversion = 'WAITING_TO_SEND_CONTRACT'

  if (processType === 'CONVERSION_CONTRACT_PROCESS_MEX') {
    return availableTransitions.CANCELLABLE_STATUSES.includes(processStatus) || processStatus === cancelableStatusForConversion
  } else return availableTransitions.CANCELLABLE_STATUSES.includes(processStatus)
}

export function showAbortButton(actorRoles, processType, processStatus) {
  return (
    availableTransitions.ABORTABLE_STATUSES.includes(processStatus) &&
    processType === 'HIRING_CONTRACT_PROCESS_MEX' &&
    isAuthorized(actorRoles, siteClearance.admin)
  )
}

export function showCancelLeaveProcessButton(actorRoles, processStatus) {
  return availableTransitions.LEAVE_TRANSITIONS.CANCELLABLE_STATUSES.includes(processStatus) && isAuthorized(actorRoles, siteClearance.admin)
}

export function isAuthorized(actorRole, clearanceArr) {
  if (!actorRole || !clearanceArr) return false

  return clearanceArr.includes(actorRole.code)
}

export function hasPermission(actorPermissions, permission) {
  if (!actorPermissions || !permission) return false

  return actorPermissions[permission] === true
}
